import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "./Swipper.css";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

const Category2 = ({ data }) => {
  // Dummy data for categories with placeholder images
  const [backgroundColor, setBackgroundColor] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [title, setTitle] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [titleSize, setTitleSize] = useState("");
  const [labelFont, setLabelFont] = useState("");
  const [labelColor, setLabelColor] = useState("");


  const swiperRef_c_2 = useRef(null);



  const component = data;
  const categories = data["get_home_component_details"]["content"];

  useEffect(() => {
    setBackgroundColor(component.web_background_color);
    setTitle(component.title);
    setTitleColor(component.web_title_color);
    setTitleFont(component.web_title_font);
    setTitleSize(component.title_size);
    setLabelFont(component.label_font);
    setLabelColor(component.label_color);
  }, []);

  const truncateNameMobile = (name) => {
    return name.length > 6 ? name.substring(0, 6) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 15 ? name.substring(0, 15) + "..." : name;
  };


  const loadGoogleFont = (fontName) => {
    if (!fontName) return;

    const f = fontName.trim();
    const lower = f.toLowerCase();

    if (lower === "sans" || lower === "serif" || lower === "mono") return;

    const formatted = f.replace(/\s+/g, "+");
    const id = `gf-${formatted.toLowerCase()}`;

    if (document.getElementById(id)) return;

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${formatted}&display=swap`;
    document.head.appendChild(link);
  };

  const getFontFamily = (font) => {
    if (!font) return "inherit";

    const f = font.toLowerCase().trim();

    if (f === "sans") return "ui-sans-serif, system-ui, -apple-system, sans-serif";
    if (f === "serif" || f === "sherif")
      return 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
    if (f === "mono")
      return 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

    return font;
  };

  useEffect(() => {

    loadGoogleFont(titleFont);
    loadGoogleFont(labelFont);
  }, [titleFont]);

  return (
    <div className="px-2 py-3" style={{ backgroundColor: backgroundColor }}>
      <div
        className={`text-2xl font-bold ${titleAlignment === "center"
            ? "text-center"
            : titleAlignment === "start"
              ? "text-left"
              : "text-center"
          }`}
        style={{
          color: titleColor,
          fontFamily: getFontFamily(titleFont),
          textSizeAdjust: titleSize,
        }}
      >
        {title}
      </div>
      {/* Padding on both sides */}
      {/* Desktop View: 6 Cards per Row, No Gap, Fully Rounded */}
      <div className="flex-wrap justify-center hidden space-x-0 overflow-hidden lg:flex">
        {categories.map((category) => (
          <div
            key={category.maincategory_auto_id}
            className="flex justify-center"
          >
            <div
              className="flex items-center p-2 text-center"
              style={{ maxWidth: "160px" }}
            >
              <Link
                to={`/maincategory/${category.maincategory_auto_id}`}
                className="flex flex-col items-center text-decoration-none"
              >
                {/* Fully Rounded Image */}
                <img
                  src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                  alt={category.main_category_name}
                  className="object-cover rounded-full"
                  style={{
                    height: "140px",
                    width: "140px",

                  }}
                />
                <p className="mt-2 text-sm " style={{ color: labelColor || "#000000", fontFamily: getFontFamily(labelFont) }}>
                  {truncateNameDesktop(category.main_category_name)}
                </p>
              </Link>
            </div>
          </div>
        ))}
      </div>
      {/* Mobile View: Rounded Carousel with 4 Items */}
      <div className="relative lg:hidden">
        <Swiper
          ref={swiperRef_c_2}
          slidesPerView={5}
          spaceBetween={10}
          navigation={{
            nextEl: `.swiper-button-next-${data._id}`,
            prevEl: `.swiper-button-prev-${data._id}`,
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {categories.map((category) => (
            <SwiperSlide key={category.maincategory_auto_id}>
              <div className="flex justify-center">
                <div className="flex items-center p-1 text-center">
                  <Link
                    to={`/maincategory/${category.maincategory_auto_id}`}
                    className="flex flex-col items-center text-decoration-none"
                  >
                    {/* Fully Rounded Image */}
                    <img
                      src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/categories/${category.category_image_app}`}
                      alt={category.main_category_name}
                      className="object-cover rounded-full"
                      style={{ height: "64px", width: "64px" }}
                    />
                    <p className="text-[13px] sm:text-[14px] font-semibold  mt-2 text-center tracking-wide" style={{ color: labelColor || "#000000", fontFamily: getFontFamily(labelFont) }}>
                      {truncateNameMobile(category.main_category_name)}
                    </p>
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Navigation Arrows */}
        <div className={`swiper-button-next-${data._id}`}></div>
        <div className={`swiper-button-prev-${data._id}`}></div>
      </div>
    </div>
  );
};

export default Category2;
